<div class="page-break-inside-avoid">
  <div class="total-block-header">{{ "LABELS.TOTALS" | translate }}</div>
  <div class="total-block">
    <div class="row">
      <div class="col label">{{ "LABELS.GROSS_WEIGHT" | translate }}</div>
      <div class="col flex-grow-0 flex-shrink-0 text-nowrap value text-right bold">
        {{ commonGrossWeight | number : "1.2-2" }} {{ WEIGHT_UNIT_KG }}
      </div>
    </div>
    <div class="row">
      <div class="col label">{{ "ENTRY_SUMMARY.TOTAL_ENTERED_VALUE" | translate }}</div>
      <div class="col flex-grow-0 flex-shrink-0 text-nowrap value text-right">
        <div class="bold">{{ enteredValue | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}</div>
      </div>
    </div>
  </div>
</div>

<div class="duties-and-taxes-block order-print-0 page-break-inside-avoid" *ngIf="dutiesValue !== null && dutiesValue !== undefined">
  <div class="row">
    <h5 class="col text-nowrap pr-0">{{ "ENTRY_SUMMARY.ESTIMATED_DUTIES_AND_FEES" | translate }}</h5>
    <h5 class="col flex-grow-0 flex-shrink-0 text-nowrap value-blue text-right">
      <span *ngIf="entrySummary.state !== enumEntrySummaryState.DUTY_CALCULATION_PENDING; else pending">
        {{ dutiesValue?.totalDue | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
      </span>

      <ng-template #pending>
        <img class="calculating" src="/assets/images/loading.gif" alt="loading" />
      </ng-template>
    </h5>
  </div>
  <div class="row">
    <div class="col-12 description">
      {{ "ENTRY_SUMMARY.DUTIES_DESCRIPTION" | translate }}
    </div>
  </div>
</div>
